import { forwardRef } from 'react';

import { InputField, type InputFieldProps } from './input-field';

type InputBucketProps = InputFieldProps;

/**
 * @deprecated Use `InputField` instead. This component is a legacy wrapper around `InputField` and may be removed in future releases.
 */
const InputBucket = forwardRef<HTMLInputElement, InputBucketProps>(({ ...props }, ref) => {
  return <InputField ref={ref} {...props} />;
});

InputBucket.displayName = 'InputBucket';

export { InputBucket };
